import { DatePicker } from "antd-mobile";
import moment from "moment";
import React, { useCallback } from "react";
import "./style.css";

const RenderDatePicker = ({
  visible = false,
  min = undefined,
  max = undefined,
  outputFormat = null,
  close = () => null,
  onConfirm = () => null,
  value,
}) => {
  const getValidDate = (val) => {
    if (!val) return null;
    // Safely replace DD/MM/YYYY to MM/DD/YYYY format for native Date parser
    const parsed = new Date(val.replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3"));
    return parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed : null;
  };

  const currentDate = getValidDate(value);

  const labelRenderer = useCallback((type, data) => {
    switch (type) {
      case "month":
        return "tháng " + data;
      default:
        return data;
    }
  }, []);

  return (
    <DatePicker
      className="datePicker-overide"
      min={min}
      max={max}
      visible={visible}
      cancelText="Quay lại"
      confirmText="Chọn"
      renderLabel={labelRenderer}
      onClose={() => close()}
      onConfirm={(val) => {
        onConfirm(moment(val).format(outputFormat || "DD/MM/YYYY"));
      }}
      value={currentDate}
    />
  );
};

export default RenderDatePicker;
